"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickChatButtonArray = QuickChatButtonArray;
const React = __importStar(require("react"));
const react_jss_1 = require("react-jss");
const react_redux_1 = require("react-redux");
const models_1 = require("@creature-chess/models");
const QuickChatButton_1 = require("./QuickChatButton");
const useStyles = (0, react_jss_1.createUseStyles)({
    root: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
    },
    buttons: {
        "background": "#1d1d1d",
        "display": "flex",
        "flexDirection": "row",
        "gap": "12px",
        "@media (orientation: portrait) and (min-width: 431px)": {
            gap: "32px",
            padding: "12px 24px",
        },
    },
});
function QuickChatButtonArray({ playerId }) {
    const styles = useStyles();
    const phase = (0, react_redux_1.useSelector)((state) => state.game.roundInfo.phase);
    const options = (0, models_1.getQuickChatOptions)(phase);
    return (React.createElement("div", { className: styles.root },
        React.createElement("div", { className: styles.buttons }, options &&
            Object.values(options).map((chat) => (React.createElement(QuickChatButton_1.QuickChatButton, { chatOption: chat, sendingPlayerId: playerId !== null && playerId !== void 0 ? playerId : null, key: chat }))))));
}
